import type { GLSelectOptions } from '@group-link-one/gl-components';
import { useMemo } from 'react';
import type { Tenant } from '@/Pages/BUs/BUManager/Components/BUPlatformList/BUPlatformList.types';

interface UseTenantUseCasesParams {
  tenants: Tenant[];
  tenantSlug: string;
}

/**
 * The active use cases of one tenant, as options keyed by **id**.
 *
 * The id is what `useCaseIds` carries, so that is the option's value — What's New keys its own
 * use-case select by slug, which is right for its payload and wrong for this one.
 */
export const useTenantUseCases = ({ tenants, tenantSlug }: UseTenantUseCasesParams) => {
  const useCaseOptions: GLSelectOptions[] = useMemo(() => {
    if (!tenantSlug) return [];

    const tenant = tenants.find(item => item.slug === tenantSlug);

    return (tenant?.useCases ?? [])
      .filter(useCase => useCase.isActive)
      .map(useCase => ({ id: useCase.id, text: useCase.name, value: useCase.id }));
  }, [tenants, tenantSlug]);

  return { useCaseOptions };
};
